var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading",style:({ '--size': _vm.loadingSize + 'px' })}),(_vm.loadingText)?_c('div',{staticClass:"loadingText"},[_vm._v(" "+_vm._s(_vm.loadingText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }